import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Api from '../../../services/Api';
import InputControl from '../InputControl/InputControl';
import './CodeInput.scss';

const CodeInput = ({
  endpoint,
  initialValue,
  onChange,
}) => {
  const [code, setCode] = useState(initialValue);
  const [isErrorShown, setIsErrorShown] = useState(false);
  const [error, setError] = useState(undefined);
  const [localTimeout, setLocalTimeout] = useState();
  const errorMessages = {
    EMPTY: 'Code cannot be empty',
    SERVER_ERROR: 'We couldnt verify the code from the server',
    TAKEN: 'An entity with this code already exists',
  };
  const handleCodeChanged = (value) => {
    if (!value) {
      setIsErrorShown(true);
      setError(errorMessages.EMPTY);
      return;
    }
    Api.get(`${endpoint}/${encodeURIComponent(value)}`, false).then((response) => {
      if (response.status !== 200) {
        setIsErrorShown(true);
        setError(errorMessages.SERVER_ERROR);
        return;
      }
      if (response.data.available) {
        setCode(value);
        setIsErrorShown(false);
        if (onChange) {
          onChange(value);
        }
      } else {
        setIsErrorShown(true);
        setError(errorMessages.TAKEN);
      }
    });
    setCode(value);
  };
  return (
    <>
      <InputControl
        value={code}
        onValueChanged={(value) => {
          setCode(value);
          clearTimeout(localTimeout);
          setLocalTimeout(setTimeout(() => handleCodeChanged(value), 750));
        }}
        label="Code"
        initialValue={code}
        type="text"
        placeholder="Code..."
        isErrorShown={isErrorShown}
        errorMessage={error}
      />
      {!isErrorShown && code && (
        <small className="code-available">
          Code
          <b>{` [${code}] `}</b>
          is available
        </small>
      )}
    </>
  );
};

CodeInput.propTypes = {
  endpoint: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
};

CodeInput.defaultProps = {
  initialValue: undefined,
  onChange: undefined,
};

export default CodeInput;
